import axios from "axios";
import * as Icons from "heroicons-react";
import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Link, useNavigate, useParams } from "react-router-dom";
import productPhoto from "../../product.jpg";
import {
  useCategoryQuery,
  useUpdateCategoryMutation,
} from "../../services/categoryApi";
import SelectCategoryGroup from "../Common/CustomSelect/selectCategoryGroup";
import Header from "../Common/Header/Header";
import SideBar from "../Common/SideBar/SideBar";
import { notify } from "../Utility/Notify";
import { signInUser } from "../Utility/Auth";

const UpdateCategory = () => {
  const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api";
  const PHOTO_BASE_URL =
    process.env.REACT_APP_PHOTO_URL || "http://localhost:5001";

  const { id } = useParams();
  const navigate = useNavigate();

  const [mc, setMc] = useState({});
  const [mg, setMg] = useState(null);
  const [fileName, setFileName] = useState("Upload Category Photo");
  const [file, setFile] = useState({});
  const [uploadFile, setUploadedFile] = useState({});

  const cat = useCategoryQuery(id);

  const { register, handleSubmit, reset } = useForm();

  useEffect(() => {
    if (cat?.data) {
      reset({
        _id: cat?.data?._id,
        name: cat?.data.name,
        mc: cat?.data?.mc ? cat?.data.mc : "",
        mcId: Number(cat?.data.mcId),
        group: cat?.data.group,
        description: cat?.data.description,
        code: cat?.data.code,
        status: cat?.data.status,
      });
      setMg(cat?.data.group);
      setMc(cat?.data?.mc ? cat?.data.mc : "");
      setUploadedFile({
        fileName: cat?.data?.name,
        filePath: cat?.data?.photo ? cat?.data?.photo : productPhoto,
      });
    }
  }, [cat?.isSuccess]);

  const [updateCategory] = useUpdateCategoryMutation();

  const updateHandler = async (data) => {
    let category = {
      ...data,
      group: (typeof mg === "object" && mg?._id) ? mg._id : (mg || null),
      _id: cat.data._id
    };
    const response = await updateCategory(category);
    if (response) {
      notify("User Update Successful!", "success");
      navigate("/category");
    } else {
      notify("Error updating category", "error");
    }
  };

  const handleOnchange = (e) => {
    setMc(e.option);
    let mCat = e.label.split(" - ");
    reset({
      mc: e.option,
      mcId: mCat[1],
    });
  };

  const handleCategoryPhoto = async (e) => {
    setFile(e.target.files[0]);
    setFileName(e.target.files[0].name);
  };

  const handleCategoryPhotoUpload = async (e) => {
    e.preventDefault();
    const user = signInUser() || {};
    const formData = new FormData();
    formData.append("file", file);
    formData.append("aamarId", user?.aamarId || "default");
    try {
      const res = await axios.post(
        `${BASE_URL}/category/upload/${id}`,
        formData,
        {
          "Content-type": "multipart/form-data",
        }
      );
      const { fileName, filePath } = res.data;
      setUploadedFile({ fileName, filePath });
    } catch (err) {
      console.log("Error uploading file:", err.response || err);
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-2">
          <SideBar />
        </div>
        <div className="col-md-10">
          <Header title={`Update Category: ${cat?.data?.name}`} />
          <div className="row mt-5 pt-3">
            <div className="col-md-6 offset-md-1">
              <Form onSubmit={handleSubmit(updateHandler)}>
                <Form.Group className="mb-3" controlId="formBasicName">
                  <Form.Label>Category Name</Form.Label>
                  <Form.Control
                    {...register("name", { required: true })}
                    type="text"
                    placeholder="Category Name"
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Category Description</Form.Label>
                  <textarea
                    className="form-control"
                    placeholder="Write a description..."
                    {...register("description", {
                      required: true,
                      maxLength: 1000,
                    })}
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPhone">
                  <Form.Label>Group</Form.Label>
                  <SelectCategoryGroup mg={mg} handleOnchange={setMg} />
                </Form.Group>

                <div className="row">
                  <div className="col-md-6">
                    <Form.Group className="mb-3" controlId="formBasicType">
                      <Form.Label>Code</Form.Label>
                      <Form.Control
                        {...register("mcId", { required: true })}
                        type="number"
                        placeholder="Master Category ID"
                        disabled
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group className="mb-3" controlId="formBasicStatus">
                      <Form.Label>Status</Form.Label>
                      <Form.Select {...register("status")}>
                        <option value="active">Active</option>
                        <option value="suspend">Suspend</option>
                      </Form.Select>
                    </Form.Group>
                  </div>
                </div>

                <Link to="/category" className="btn btn-outline-dark me-2">
                  <Icons.X size={20} /> Cancel
                </Link>

                <Button variant="dark" type="submit">
                  <Icons.SaveOutline size={20} /> Update Category
                </Button>
              </Form>
            </div>
            <div className="col-md-4">
              <Form onSubmit={(e) => handleCategoryPhotoUpload(e)}>
                <div className="card">
                  <img
                    className="card-img-top"
                    src={
                      `${process.env.REACT_APP_PHOTO_URL}${encodeURIComponent(
                        cat?.data?.photo
                      )}` || productPhoto
                    }
                    alt="Category Photo"
                  />
                  <div className="card-body">
                    <Form.Group controlId="formFile" className="mb-3">
                      <Form.Label className="text-wrap w-100">
                        {cat?.data?.name}
                      </Form.Label>
                      <Form.Control
                        name="c_photo"
                        type="file"
                        onChange={(e) => handleCategoryPhoto(e)}
                      />
                    </Form.Group>
                  </div>
                  <div className="card-footer">
                    <div className="d-grid gap-2">
                      <Button type="submit" variant="dark" size="lg">
                        <Icons.UploadOutline size={20} /> Save Photo
                      </Button>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateCategory;
